<template>
  <button
    class="shadow-md border-2 inline-flex focus:outline-none select-none whitespace-nowrap"
    :class="[isLightMode() ? lightModeClasses : darkModeClasses, { 'cursor-not-allowed': disabled }]"
    :disabled="disabled"
    :style="`padding: ${padding_top}px ${padding_right}px ${padding_bottom}px ${padding_left}px; border-radius: ${border_radius}rem; font-weight: ${font_weight}; transition:background 0.25s;`"
    @keydown.enter.exact.prevent="click()"
  >
    <span class="material-icons my-auto px-1" :class="`${iconSize}`">
      {{ icon }}
    </span>
    <div class="pr-2 my-auto" :class="`${textSize}`">
      {{ text }}
    </div>
  </button>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  props: {
    border_radius: {
      type: Number,
      default: 0.5
    },
    color_list: {
      type: Array,
      default: () => [
        'text-primary-500',
        'border-primary-500',
        'hover:text-primary-600',
        'hover:bg-gray-200',
        'disabled:text-primary-200',
        'disabled:border-primary-200',
        'disabled:bg-white',
        'active:text-primary-700',
        'active:bg-gray-300'
      ]
    },
    dark_color_list: {
      type: Array,
      default: () => [
        'text-primary-400',
        'border-primary-400',
        'hover:text-primary-500',
        'hover:bg-dark-800',
        'disabled:text-primary-600',
        'disabled:border-primary-600',
        'disabled:bg-transparent',
        'active:text-primary-600',
        'active:bg-dark-900'
      ]
    },
    font_weight: {
      type: String,
      default: '400'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    },
    textSize: {
      type: String,
      default: ''
    },
    padding_top: {
      type: Number,
      default: 1
    },
    padding_bottom: {
      type: Number,
      default: 1
    },
    padding_left: {
      type: Number,
      default: 1
    },
    padding_right: {
      type: Number,
      default: 1
    }
  },
  setup(props, ctx) {
    const { isLightMode } = useConfigStatePresenter()

    const lightModeClasses = computed(() => props.color_list)

    const darkModeClasses = computed(() => props.dark_color_list)

    const click = () => {
      ctx.emit('click')
    }

    return { click, isLightMode, lightModeClasses, darkModeClasses }
  }
})
</script>

<style lang="postcss" scoped></style>
